import { AxiosPromise } from 'axios';
import { URLS } from '@/services/Constants';
import { commonAxios as axios } from '@/services/Authentication';

export default {
    // GET

    /**
     * Return all voicemailboxes
     *
     * @returns {AxiosPromise<any>}
     */
    getAllVoicemailboxes(): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlVoicemailboxes,
            method: 'get'
        });
    },

    /**
     * Return voicemailbox by Id
     *
     * @param {string} voicemailboxId
     * @returns {AxiosPromise<any>}
     */
    getVoicemailboxById(voicemailboxId: string): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlVoicemailboxes + '/' + voicemailboxId,
            method: 'get'
        });
    },

    // POST

    /**
     * Create new voicemailbox
     *
     * @param {*} data
     * @returns {AxiosPromise<any>}
     */
    createVoicemailbox(data: any): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlVoicemailboxes,
            method: 'post',
            data
        });
    },

    // PUT

    /**
     * Update voicemailbox according to provided data
     *
     * @param {*} data
     * @returns {AxiosPromise<any>}
     */
    updateVoicemailbox(data: any): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlVoicemailboxes,
            method: 'put',
            data
        });
    },

    // DELETE

    /**
     * Remove voicemailbox by Id
     *
     * @param {string} voicemailboxId
     * @returns {AxiosPromise<any>}
     */
    deleteVoicemailbox(voicemailboxId: string): AxiosPromise<any> {
        return axios().request({
            url: URLS().urlVoicemailboxes + '/' + voicemailboxId,
            method: 'delete'
        });
    }
};
